import { render } from "./informationComponent.vue?vue&type=template&id=8e6c6c56"
import script from "./informationComponent.vue?vue&type=script&lang=js"
export * from "./informationComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__